import TravelerProfileNotesSection from './traveler-profile-notes-section-container';

export type { TravelerNote, TravelerNoteStatus } from '@marageti/z4-sdk/lib/people';

export default TravelerProfileNotesSection;
